<template>

    <div class="wrapper">
        <div class="section section-blogs-2 topsearch">
                <div class="container main">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
                            <router-link id="buttonback" :to="{ name: 'objList', params: {dictionaryId: dictCode, page: page} }">
                                <md-icon>keyboard_arrow_left</md-icon> Назад к списку справочников
                            </router-link>
                        </div>
                        <div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

                                <div class="name">
                                    <h3 class="title">Редактирование элемента справочника</h3>
                                    <div v-if="selectedDataId" class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep">


                                        <div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
                                            <md-field :class="getValidationClass('roomCode')">
                                                <label>{{mapElementName['roomCode']}}</label>
                                                <md-input v-if="action === 'delete'" v-model="form['roomCode']" type="text"></md-input>
                                                <md-input v-else v-model="form['roomCode']" type="text"></md-input>
                                                <span class="md-error" v-if="!$v.form.roomCode.required">Обязательно для заполнения</span>
                                            </md-field>
                                        </div>

                                        <div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
                                            <md-field :class="getValidationClass('roomName')">
                                                <label>{{mapElementName['roomName']}}</label>
                                                <md-input v-if="action === 'delete'" readonly v-model.number="form['roomName']" type="text"></md-input>
                                                <md-input v-else v-model="form['roomName']" type="text"></md-input>
                                                <span class="md-error" v-if="!$v.form.roomName.required">Обязательно для заполнения</span>
                                            </md-field>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

                                        <template v-if="selectedDataId">
                                            <md-button v-if="action !== 'delete'"
                                                       @click="validateData(saveItem)"
                                                       class="md-button md-success md-theme-default">
                                                Сохранить
                                            </md-button>

                                            <md-button v-if="action === 'delete'"
                                                       @click="validateData(deleteItem)"
                                                       class="md-button md-primary  md-theme-default">
                                                Удалить
                                            </md-button>

                                        </template>
                                    </div>
                                </div>


                        </div>
                    </div>

                </div>
        </div>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import {
        required
    } from 'vuelidate/lib/validators'
    import { saveItem, getItem, deleteItem } from '@/utils/dict-api'

    export default {
        mixins: [
            validationMixin
        ],
        bodyClass: "dictionary-data",
        props: ['page', 'action'],
        data () {
            return {
                options: [],
                dictCode: this.$route.params.dictCode,
                dictionaryId: '',
                selectedDataId: this.$route.params.id,
                selectedData: null,
                form: {
                    action: 'save',
                    roomCode: '',
                    order: 1,
                    roomName: '',
                },
                mapElementName: {
                    "order": 'Порядок отображения',
                    "roomCode": "Код",
                    "roomName": 'Название',
                }
            }
        },
        validations: {
            form: {
                roomCode: {
                    required
                },
                roomName: {
                    required
                },
            }
        },
        watch: {
        },
        methods: {
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function(data) {
                this.form = data
            },
            getElementData: function() {
                if(this.selectedDataId === 'new') {
                    this.addItem()
                    return
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('room', this.selectedDataId).then(result => {
                        this.setData(result)
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                });
            },
            addItem: function() {
                const item = {
                    "id": null,
                    "roomCode": "",
                    "roomName": ""
                };
                this.setData(item)

            },
            deleteItem: function() {
                checkAuthentication(this.$router, this.$route).then(response => {
                    deleteItem('room/type', JSON.stringify({id: this.$route.params.id})).then(result => {
                        this.$router.push({ name: 'objList', params: { dictCode: 'objList' } })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error);
                    });
                });
            },
            saveItem: function() {
                if(this.form.id === 'new') {
                    this.form.id = null
                }
                saveItem('room/type', JSON.stringify(this.form)).then(result => {
                    this.$router.push({ name: 'objList', params: { dictCode: 'objList' } })

                }).catch(error => {
                    reAuthenticate(this.$router, this.$route, error)
                })
            },
            checkEditableNames: function(name) {
                const editableNames = ['valueId', 'value', 'order']
                return (editableNames.indexOf(name) >= 0)
            }
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem();
            } else {
                this.getElementData();
            }
        }
    }
</script>


<style lang="scss" scoped type="text/scss">
    .dictionary-data .md-field{
        padding-top: 16px;
        margin: 4px 0 24px;
    }
    .offset-left-16 {
        margin-left: 16px;
    }
</style>
